import React, { FC } from 'react';

import { Text, Stack, Badge, BadgeProps } from '@mantine/core';

import { Gradient } from '@/../marketing/helpers/gradient';

import cx from './Section.module.css';

export type SectionHeaderProps = {
    title?: React.ReactNode;
    titleGradient?: Gradient;
    description?: React.ReactNode;
    prefix?: React.ReactNode;
    prefixProps?: BadgeProps & { component?: any; href?: string };
};

const SectionHeader: FC<SectionHeaderProps> = ({ title, description, prefix, prefixProps = {} }) => (
    <Stack align="center" gap="sm">
        {prefix && (
            <Badge
                color="cyan.5"
                variant="transparent"
                className="gradient-cyan-green-background-light"
                {...prefixProps}
            >
                <span className="gradient-cyan-green">{prefix}</span>
            </Badge>
        )}
        {title && (
            <Text className={cx.title} ta="center" fz={{ base: 24, md: 40 }} fw={800} maw={800}>
                {title}
            </Text>
        )}
        {description && (
            <Text fz={15} fw={500} opacity={0.8} maw={480} ta="center" mx="auto">
                {description}
            </Text>
        )}
    </Stack>
);

export { SectionHeader };
